import { FileUpload } from "components/RFQ/FileUpload";
import { FILE_UPLOAD_TYPES, fileUpload } from "newui/components/FileUpload";
import { removeProgressFromUploading } from "utils/rfxLargeFileUploadHelper";

export const RSFileUploadTemplate = ({
	setFieldValue,
	setUploadInProgresses,
	rfxTemplateId,
}) => {
	const handleFileUploadComplete = (uploadedFile) => {
		const fileId = uploadedFile?.file?.id || uploadedFile?.id;

		if (fileId) {
			setFieldValue("returnable_schedule_file_id", fileId);
			setFieldValue("returnable_schedule_file", null);
			setFieldValue(
				"returnable_schedule_file_path",
				uploadedFile?.file?.path || uploadedFile?.path || ""
			);
		} else {
			setFieldValue("returnable_schedule_file_id", null);
			setFieldValue("returnable_schedule_file", null);
			setFieldValue("returnable_schedule_file_path", "");
		}

		setUploadInProgresses((prev) => removeProgressFromUploading(prev, true));
	};

	const onDeleteFile = async (file) => {
		return fileUpload.util.deleteFileUpload(
			file,
			FILE_UPLOAD_TYPES.RETURNABLE_SCHEDULE_FILE_TEMPLATE
		);
	};

	return (
		<FileUpload
			name="returnable_schedule_file"
			types={["pdf", "docx", "doc", "xlsx", "xls"]}
			required
			singleFile
			setFieldValue={setFieldValue}
			label="Upload Returnable Schedules Template"
			description="Please upload your returnable schedule template"
			fileExtraData={{
				model: FILE_UPLOAD_TYPES.RETURNABLE_SCHEDULE_FILE_TEMPLATE,
				rfxTemplateId: rfxTemplateId,
			}}
			handleFileUploadComplete={handleFileUploadComplete}
			isProcurerRFx
			testId="returnable-schedule-file"
			onDelete={onDeleteFile}
		/>
	);
};
